export default __webpack_public_path__ + "static/media/LevelingMountsImg.2e2c6632.jpg";